<body>
<div class="introBack">

  <!-- NAVBAR -->
  <mat-toolbar class="main-nav">
    <button mat-icon-button (click)="sidenav.toggle()" class="nav-hamburger" *ngIf="isHandset$ | async">
      <mat-icon>menu</mat-icon>
    </button>
    <a class="nav-brand" *ngIf="isHandset$ | async" (click)="sidenav.toggle()" style="cursor:pointer" style=" user-select: none !important;  -webkit-user-drag: none !important; ">
      <img src="../../../assets/images/BackGround/logoBTN.PNG" alt="Posgrado" class="icon-img imgPuma">
      <span>Posgrados</span>
    </a>
    <a class="nav-brand" *ngIf="!(isHandset$ | async)" style="cursor:default" style=" user-select: none !important;  -webkit-user-drag: none !important; ">
      <img src="../../../assets/images/BackGround/logoBTN.PNG" alt="Posgrado" class="icon-img imgPuma">
      <span>Posgrados</span>
    </a>
    <div class="nav-spacer"></div>
    <div class="nav-links" *ngIf="!(isHandset$ | async)" style=" user-select: none !important;  -webkit-user-drag: none !important; ">
      <button class="nav-btn" (click)="loginEstudiante()">Estudiantes</button>
      <button class="nav-btn" (click)="loginAdministrativo1()">Docentes</button>
      <button class="nav-btn" (click)="loginAdministrativo2()">Coordinador Posgrado</button>
      <button class="nav-btn" (click)="loginAdministrativo3()">Coordinador General</button>
      <div class="nav-dropdown">
        <button class="nav-btn" [matMenuTriggerFor]="adminMenu">Administrativo ▾</button>
        <mat-menu #adminMenu="matMenu">
          <button mat-menu-item class="custom-hover" (click)="loginAdministrativo4()">DSEP</button>
          <button mat-menu-item class="custom-hover" (click)="loginAdministrativo5()">DIPP</button>
          <button mat-menu-item class="custom-hover" [matMenuTriggerFor]="dsaMenu">DSA</button>
        </mat-menu>
        <mat-menu #dsaMenu="matMenu">
          <button mat-menu-item class="custom-hover" (click)="loginDSA1()">Dirección - DSA</button>
          <button mat-menu-item class="custom-hover" (click)="loginComisionDSA()">Comisión</button>
          <!-- <button mat-menu-item class="custom-hover" (click)="loginPostulante()">Postulante</button> -->
        </mat-menu>
      </div>
    </div>
  </mat-toolbar>

  <!-- SIDENAV -->
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav mode="over" class="sidenav" fixedInViewport="true">
      <button class="sidenav-back" (click)="sidenav.close()">
        <mat-icon>arrow_back</mat-icon> Atrás
      </button>
      <ul class="sidenav-nav">
        <li><a class="sidenav-link" (click)="loginEstudiante()">Estudiantes</a></li>
        <li><a class="sidenav-link" (click)="loginPostulante()">Postulante</a></li>
        <li><a class="sidenav-link" (click)="loginAdministrativo1()">Docentes</a></li>
        <li><a class="sidenav-link" (click)="loginAdministrativo2()">Coordinador de Posgrado</a></li>
        <li><a class="sidenav-link" (click)="loginAdministrativo3()">Coordinador General</a></li>
        <li><a class="sidenav-link" (click)="loginAdministrativo4()">DSEP</a></li>
        <li><a class="sidenav-link" (click)="loginAdministrativo5()">DIPP</a></li>
        <li>
          <a class="sidenav-link" (click)="mostrarSubmenuDSA = !mostrarSubmenuDSA">
            DSA
            <mat-icon class="sidenav-submenu-caret" [class.abierto]="mostrarSubmenuDSA">expand_more</mat-icon>
          </a>
          <ul class="sidenav-submenu" *ngIf="mostrarSubmenuDSA">
            <li><a class="sidenav-link" (click)="loginDSA1()">Dirección - DSA</a></li>
            <li><a class="sidenav-link" (click)="loginComisionDSA()">Comisión</a></li>
            <!-- <li><a class="sidenav-link" (click)="loginPostulante()">Postulante</a></li> -->
          </ul>
        </li>
      </ul>
    </mat-sidenav>

    <mat-sidenav-content>

      <!-- HERO -->
      <section class="hero">
        <div class="hero-geo">
          <div class="hero-shape shape-ring-lg"></div>
          <div class="hero-shape shape-ring-sm"></div>
          <div class="hero-shape shape-sq1"></div>
          <div class="hero-shape shape-sq2"></div>
          <div class="hero-shape shape-diamond"></div>
          <div class="hero-shape shape-cross"></div>
        </div>
        <div class="hero-diag"></div>
        <div class="hero-content">
          <div style=" user-select: none !important;  -webkit-user-drag: none !important; ">
            <div class="hero-badge anim d1">
              <i class="fas fa-graduation-cap" style="font-size:12px"></i>
              Posgrados · UNAH
            </div>
            <h1 class="hero-title anim d2">
              Impulsa tu<br><span>futuro profesional</span><br>con un Posgrado
            </h1>
            <p class="hero-sub anim d3">
              Programas de posgrados de alto nivel diseñados para líderes y profesionales comprometidos con el desarrollo de Honduras.
            </p>
            <div class="hero-actions-row anim d4">
              <div class="hero-actions"
                   (mouseover)="showTooltip = true"
                   (mouseleave)="showTooltip = false">
                <a class="btn-primary" (click)="ofertaAcademica()" style="cursor:pointer">
                  <i class="fas fa-book-open" style="font-size:14px"></i>
                  Oferta Académica
                </a>
                <div *ngIf="showTooltip" class="card-tooltip-glass">
                  <p class="tooltip-title-glass"><i class="fas fa-book-open"></i> Oferta Académica</p>
                  <p class="tooltip-desc-glass">Haz clic y explora nuestras ofertas académicas diseñadas para impulsar tu carrera profesional.</p>
                </div>
              </div>

              <div class="hero-actions-secondary"
                   (mouseover)="showTooltipSeguimiento = true"
                   (mouseleave)="showTooltipSeguimiento = false">
                <a class="btn-outline-hero" (click)="loginPostulante()" style="cursor:pointer">
                  <span class="btn-outline-hero-icon"><i class="fas fa-user-check"></i></span>
                  ¿Ya postulaste? Da seguimiento
                </a>
                <div *ngIf="showTooltipSeguimiento" class="card-tooltip-glass card-tooltip-glass--seguimiento">
                  <p class="tooltip-title-glass"><i class="fas fa-info-circle"></i> Seguimiento de Postulación</p>
                  <p class="tooltip-desc-glass">Aquí podrá dar seguimiento a los documentos requeridos durante el proceso de revisión de su solicitud.<br> Disponible únicamente para las carreras que tienen habilitado este proceso.</p>
                </div>
              </div>
            </div>
          </div>

          <!-- HERO VISUAL -->
          <div class="hero-visual">
            <div class="hero-visual-col">
              <div class="hero-img-wrap">
                <svg class="hex-svg" viewBox="0 0 340 360" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <!-- Hex exterior giratorio con líneas doradas más vívidas -->
                  <g class="hex-spin">
                    <polygon points="170,8 318,92 318,268 170,352 22,268 22,92"
                      stroke="#ff9900" stroke-width="2" fill="none"/>
                    <!-- Diamantes en vértices - más brillantes -->
                    <polygon points="170,4 180,14 170,24 160,14" fill="rgba(255, 153, 0, 0.5)"/>
                    <polygon points="314,85 324,95 314,105 304,95" fill="rgba(255, 153,10,0.65)"/>
                    <polygon points="314,253 324,263 314,273 304,263" fill="rgba(255, 153,10,0.5)"/>
                    <polygon points="170,345 180,355 170,365 160,355" fill="rgba(255, 153,10,0.65)"/>
                    <polygon points="26,253 36,263 26,273 16,263" fill="rgba(255, 153,10,0.5)"/>
                    <polygon points="26,85 36,95 26,105 16,95" fill="rgba(255, 153,10,0.4)"/>
                  </g>
                  <!-- Hex interior punteado con tono dorado -->
                  <g class="hex-spin2">
                    <polygon points="170,48 298,122 298,238 170,312 42,238 42,122"
                      stroke="rgba(254,202,10,0.28)" stroke-width="1.2" fill="none" stroke-dasharray="7 5"/>
                  </g>
                  <!-- Hex central con relleno cristal -->
                  <polygon points="170,80 274,138 274,222 170,280 66,222 66,138"
                    fill="rgba(255,255,255,0.07)" stroke="rgba(254,202,10,0.22)" stroke-width="1.2"/>
                </svg>
                <div class="hero-grad-icon" style=" user-select: none !important;  -webkit-user-drag: none !important; ">🎓</div>
              </div>
              <div class="vra-badge">
                <div class="vra-line"></div>
                <img src="../../assets/images/BackGround/DSEPUNAH.PNG"
                     alt="VRA - Dirección del Sistema de Estudios de Posgrado"
                     class="vra-logo-img imgPuma" style=" user-select: none !important;  -webkit-user-drag: none !important; ">
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- WAVE DIVIDER -->
      <div class="wave-divider">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,0 C360,60 1080,0 1440,60 L1440,0 Z" fill="#013775"/>
        </svg>
      </div>

      <!-- PROGRAMS SECTION -->
      <section class="programs" style=" user-select: none !important;  -webkit-user-drag: none !important; ">
        <div class="section-header">
          <span class="section-label">Programas académicos</span>
          <h2 class="section-title">Nuestras ofertas de posgrados</h2>
          <p class="section-sub">Formación de alto nivel impartida por docentes de excelencia.</p>
          <div class="title-line"></div>
        </div>

        <div class="cards-grid">
          <ng-container *ngFor="let item of maestrias; let i = index">
            <div class="prog-card" [ngClass]="'card-idx-' + (i % 8)" (click)="ofertaAcademica()" style="cursor:pointer">
              <div class="prog-card-illo">

                <!-- SVG 0: Tecnología -->
                <ng-container *ngIf="i % 8 === 0">
                  <svg width="200" height="110" viewBox="0 0 200 120">
                    <rect x="50" y="16" width="100" height="65" rx="7" fill="#1A56C4" style="animation:float1 3s ease-in-out infinite"/>
                    <rect x="60" y="24" width="80" height="48" rx="3" fill="#E8F0FE" style="animation:float1 3s ease-in-out infinite"/>
                    <rect x="67" y="31" width="32" height="3.5" rx="2" fill="#1A56C4" opacity="0.45"/>
                    <rect x="67" y="39" width="48" height="3.5" rx="2" fill="#378ADD" opacity="0.55"/>
                    <rect x="67" y="47" width="26" height="3.5" rx="2" fill="#1A56C4" opacity="0.4"/>
                    <rect x="67" y="55" width="40" height="3.5" rx="2" fill="#378ADD" opacity="0.5"/>
                    <rect x="93" y="81" width="14" height="10" rx="2" fill="#185FA5" style="animation:float1 3s ease-in-out infinite"/>
                    <rect x="80" y="91" width="40" height="5" rx="2.5" fill="#185FA5" style="animation:float1 3s ease-in-out infinite"/>
                    <circle cx="168" cy="28" r="8" fill="#7EB3FF" opacity="0.65" style="animation:float2 2.6s ease-in-out infinite"/>
                    <circle cx="24" cy="62" r="6" fill="#B5D4F4" opacity="0.8" style="animation:float3 3.4s ease-in-out infinite"/>
                    <circle cx="178" cy="80" r="5" fill="#378ADD" opacity="0.4" style="animation:float2 4s ease-in-out infinite .5s"/>
                  </svg>
                </ng-container>

                <!-- SVG 1: Salud Mental / Psicología Clínica -->
                <ng-container *ngIf="i % 8 === 1">
                  <svg width="200" height="110" viewBox="0 0 200 120">
                    <!-- Outer dashed ring -->
                    <circle cx="96" cy="56" r="50" fill="none" stroke="#26C6DA" stroke-width="1.2" stroke-dasharray="5 3" opacity="0.45" style="animation:float2 10s linear infinite"/>
                    <!-- Inner dashed ring -->
                    <circle cx="96" cy="56" r="35" fill="none" stroke="#FDD835" stroke-width="1" stroke-dasharray="3 4" opacity="0.6"/>
                    <!-- Head silhouette -->
                    <ellipse cx="96" cy="42" rx="23" ry="25" fill="#00ACC1" opacity="0.78" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Neck -->
                    <rect x="89" y="65" width="14" height="12" rx="2" fill="#00ACC1" opacity="0.78" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Ears -->
                    <ellipse cx="73" cy="44" rx="4" ry="5.5" fill="#00ACC1" opacity="0.6" style="animation:float1 3.5s ease-in-out infinite"/>
                    <ellipse cx="119" cy="44" rx="4" ry="5.5" fill="#00ACC1" opacity="0.6" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Brain -->
                    <ellipse cx="96" cy="36" rx="15" ry="13" fill="#EF5350" opacity="0.88" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Brain center division -->
                    <line x1="96" y1="24" x2="96" y2="49" stroke="#B71C1C" stroke-width="1" opacity="0.4" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Brain fold top -->
                    <path d="M83 33 Q87 27 92 32 Q96 27 101 32 Q105 27 109 33" stroke="#B71C1C" stroke-width="1.2" fill="none" stroke-linecap="round" opacity="0.65" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Brain fold bottom -->
                    <path d="M83 40 Q88 46 96 42 Q104 46 109 40" stroke="#B71C1C" stroke-width="1.2" fill="none" stroke-linecap="round" opacity="0.55" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Medical cross -->
                    <rect x="151" y="11" width="8" height="24" rx="2.5" fill="#EF5350" style="animation:float3 3.2s ease-in-out infinite"/>
                    <rect x="143" y="19" width="24" height="8" rx="2.5" fill="#EF5350" style="animation:float3 3.2s ease-in-out infinite"/>
                    <!-- Gear (spinning) -->
                    <g style="transform-box:fill-box;transform-origin:center;animation:spin 8s linear infinite">
                      <circle cx="32" cy="88" r="10" fill="none" stroke="#00ACC1" stroke-width="2.2"/>
                      <circle cx="32" cy="88" r="4" fill="#00ACC1"/>
                      <rect x="29.5" y="76.5" width="5" height="4" rx="1" fill="#00ACC1"/>
                      <rect x="29.5" y="97.5" width="5" height="4" rx="1" fill="#00ACC1"/>
                      <rect x="19.5" y="85.5" width="4" height="5" rx="1" fill="#00ACC1"/>
                      <rect x="40.5" y="85.5" width="4" height="5" rx="1" fill="#00ACC1"/>
                      <rect x="22.5" y="77" width="4" height="4" rx="1" fill="#00ACC1" transform="rotate(45 24.5 79)"/>
                      <rect x="22.5" y="93" width="4" height="4" rx="1" fill="#00ACC1" transform="rotate(45 24.5 95)"/>
                      <rect x="38.5" y="77" width="4" height="4" rx="1" fill="#00ACC1" transform="rotate(45 40.5 79)"/>
                      <rect x="38.5" y="93" width="4" height="4" rx="1" fill="#00ACC1" transform="rotate(45 40.5 95)"/>
                    </g>
                    <!-- Psi Ψ: halo de fondo -->
                    <circle cx="163" cy="80" r="24" fill="#00ACC1" opacity="0.09" style="animation:float2 2.8s ease-in-out infinite"/>
                    <!-- Vastago central -->
                    <line x1="163" y1="54" x2="163" y2="104" stroke="#00ACC1" stroke-width="3.8" stroke-linecap="round" style="animation:float2 2.8s ease-in-out infinite"/>
                    <!-- Brazo izquierdo: sale horizontal y sube curvado -->
                    <path d="M163 79 Q138 80 142 58" stroke="#00ACC1" stroke-width="3.2" fill="none" stroke-linecap="round" style="animation:float2 2.8s ease-in-out infinite"/>
                    <!-- Brazo derecho: espejo -->
                    <path d="M163 79 Q188 80 184 58" stroke="#00ACC1" stroke-width="3.2" fill="none" stroke-linecap="round" style="animation:float2 2.8s ease-in-out infinite"/>
                    <!-- Barra horizontal base -->
                    <line x1="154" y1="102" x2="172" y2="102" stroke="#00ACC1" stroke-width="3.2" stroke-linecap="round" style="animation:float2 2.8s ease-in-out infinite"/>
                    <!-- Accent dots -->
                    <circle cx="18" cy="42" r="3" fill="#FDD835" opacity="0.8" style="animation:blink 2.2s ease-in-out infinite"/>
                    <circle cx="170" cy="60" r="2.5" fill="#26C6DA" opacity="0.8" style="animation:blink 2.6s ease-in-out infinite .5s"/>
                    <circle cx="64" cy="12" r="2" fill="#FDD835" opacity="0.7" style="animation:blink 1.9s ease-in-out infinite .3s"/>
                    <circle cx="22" cy="68" r="1.8" fill="#26C6DA" opacity="0.6" style="animation:blink 2.4s ease-in-out infinite .8s"/>
                  </svg>
                </ng-container>

                <!-- SVG 2: Negocios -->
                <ng-container *ngIf="i % 8 === 2">
                  <svg width="200" height="110" viewBox="0 0 200 120">
                    <rect x="54" y="66" width="18" height="28" rx="3" fill="#EF9F27" style="animation:float3 3s ease-in-out infinite"/>
                    <rect x="78" y="48" width="18" height="46" rx="3" fill="#BA7517" style="animation:float1 3.4s ease-in-out infinite"/>
                    <rect x="102" y="56" width="18" height="38" rx="3" fill="#EF9F27" opacity="0.8" style="animation:float2 2.8s ease-in-out infinite"/>
                    <rect x="126" y="36" width="18" height="58" rx="3" fill="#BA7517" style="animation:float3 3.1s ease-in-out infinite"/>
                    <line x1="46" y1="96" x2="154" y2="96" stroke="#FAC775" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M54 84 Q95 46 150 28" stroke="#854F0B" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-dasharray="70" stroke-dashoffset="70" style="animation:dash 2s ease forwards .5s"/>
                    <polygon points="150,28 140,32 146,40" fill="#854F0B"/>
                    <circle cx="172" cy="78" r="8" fill="#FAEEDA" stroke="#FAC775" stroke-width="1.5" style="animation:float2 3.8s ease-in-out infinite"/>
                    <circle cx="28" cy="44" r="6" fill="#FEF3E2" stroke="#EF9F27" stroke-width="1" style="animation:float1 4.2s ease-in-out infinite"/>
                  </svg>
                </ng-container>

                <!-- SVG 3: Ciencias Sociales -->
                <ng-container *ngIf="i % 8 === 3">
                  <svg width="200" height="110" viewBox="0 0 200 120">
                    <circle cx="100" cy="50" r="12" fill="#1D9E75" style="animation:float1 3s ease-in-out infinite"/>
                    <circle cx="66" cy="76" r="10" fill="#5DCAA5" style="animation:float2 3.5s ease-in-out infinite"/>
                    <circle cx="134" cy="76" r="10" fill="#5DCAA5" style="animation:float3 2.8s ease-in-out infinite"/>
                    <circle cx="48" cy="44" r="7" fill="#9FE1CB" style="animation:float1 4s ease-in-out infinite .3s"/>
                    <circle cx="152" cy="44" r="7" fill="#9FE1CB" style="animation:float2 3.2s ease-in-out infinite .6s"/>
                    <line x1="100" y1="62" x2="66" y2="66" stroke="#1D9E75" stroke-width="1.2" opacity="0.5"/>
                    <line x1="100" y1="62" x2="134" y2="66" stroke="#1D9E75" stroke-width="1.2" opacity="0.5"/>
                    <line x1="88" y1="46" x2="55" y2="49" stroke="#5DCAA5" stroke-width="1" opacity="0.4"/>
                    <line x1="112" y1="46" x2="145" y2="49" stroke="#5DCAA5" stroke-width="1" opacity="0.4"/>
                    <line x1="66" y1="66" x2="134" y2="66" stroke="#9FE1CB" stroke-width="1" opacity="0.3"/>
                    <circle cx="175" cy="60" r="6" fill="#E1F5EE" stroke="#5DCAA5" stroke-width="1.5" style="animation:float3 4.5s ease-in-out infinite"/>
                  </svg>
                </ng-container>

                <!-- SVG 4: Salud Pública -->
                <ng-container *ngIf="i % 8 === 4">
                  <svg width="200" height="110" viewBox="0 0 200 120">
                    <rect x="88" y="22" width="24" height="36" rx="4" fill="#D4537E" style="animation:float1 3.2s ease-in-out infinite"/>
                    <ellipse cx="100" cy="22" rx="14" ry="8" fill="#993556" style="animation:float1 3.2s ease-in-out infinite"/>
                    <rect x="76" y="76" width="48" height="8" rx="4" fill="#993556" style="animation:float1 3.2s ease-in-out infinite"/>
                    <rect x="96" y="58" width="8" height="20" rx="1.5" fill="#D4537E" style="animation:float1 3.2s ease-in-out infinite"/>
                    <circle cx="160" cy="40" r="13" fill="none" stroke="#ED93B1" stroke-width="1.5" stroke-dasharray="5 3" style="animation:float2 3s ease-in-out infinite"/>
                    <circle cx="160" cy="40" r="6" fill="#F4C0D1" style="animation:float2 3s ease-in-out infinite"/>
                    <circle cx="34" cy="58" r="10" fill="none" stroke="#ED93B1" stroke-width="1.2" stroke-dasharray="4 3" style="animation:float3 3.8s ease-in-out infinite"/>
                    <circle cx="34" cy="58" r="4.5" fill="#F4C0D1" style="animation:float3 3.8s ease-in-out infinite"/>
                    <circle cx="175" cy="82" r="5" fill="#D4537E" opacity="0.4" style="animation:blink 1.8s ease-in-out infinite"/>
                    <circle cx="22" cy="30" r="4" fill="#ED93B1" opacity="0.6" style="animation:blink 2.4s ease-in-out infinite .8s"/>
                  </svg>
                </ng-container>

                <!-- SVG 5: Humanidades -->
                <ng-container *ngIf="i % 8 === 5">
                  <svg width="200" height="110" viewBox="0 0 200 120">
                    <path d="M62 30 Q100 24 100 88 Q100 24 138 30 L138 90 Q100 82 100 88 Q100 82 62 90 Z" fill="#F0997B" style="animation:float1 3.4s ease-in-out infinite"/>
                    <line x1="100" y1="26" x2="100" y2="87" stroke="#993C1D" stroke-width="1.2" opacity="0.35"/>
                    <line x1="70" y1="44" x2="94" y2="42" stroke="#993C1D" stroke-width="1" opacity="0.3"/>
                    <line x1="70" y1="54" x2="94" y2="52" stroke="#993C1D" stroke-width="1" opacity="0.3"/>
                    <line x1="70" y1="64" x2="93" y2="62" stroke="#993C1D" stroke-width="1" opacity="0.3"/>
                    <line x1="106" y1="44" x2="130" y2="42" stroke="#993C1D" stroke-width="1" opacity="0.3"/>
                    <line x1="106" y1="54" x2="130" y2="52" stroke="#993C1D" stroke-width="1" opacity="0.3"/>
                    <line x1="106" y1="64" x2="128" y2="62" stroke="#993C1D" stroke-width="1" opacity="0.3"/>
                    <circle cx="165" cy="32" r="10" fill="#FAECE7" stroke="#F0997B" stroke-width="1.5" style="animation:float2 4s ease-in-out infinite"/>
                    <line x1="165" y1="24" x2="165" y2="40" stroke="#D85A30" stroke-width="1.2" style="animation:float2 4s ease-in-out infinite"/>
                    <line x1="157" y1="32" x2="173" y2="32" stroke="#D85A30" stroke-width="1.2" style="animation:float2 4s ease-in-out infinite"/>
                    <circle cx="32" cy="68" r="7" fill="#F5C4B3" style="animation:float3 3.6s ease-in-out infinite"/>
                    <path d="M24 82 Q30 70 38 64" stroke="#D85A30" stroke-width="1.5" fill="none" stroke-linecap="round" style="animation:float3 3.6s ease-in-out infinite"/>
                  </svg>
                </ng-container>

                <!-- SVG 6: Astronomía y Astrofísica -->
                <ng-container *ngIf="i % 8 === 6">
                  <svg width="200" height="110" viewBox="0 0 200 120">
                    <!-- Outer orbit ellipse -->
                    <ellipse cx="100" cy="60" rx="44" ry="15" fill="none" stroke="#9FA8DA" stroke-width="1.3" stroke-dasharray="6 4" style="animation:float2 5s ease-in-out infinite"/>
                    <!-- Planet -->
                    <circle cx="100" cy="60" r="20" fill="#3949AB" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Planet surface highlight -->
                    <ellipse cx="94" cy="53" rx="11" ry="6" fill="#7986CB" opacity="0.42" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Saturn-style ring -->
                    <ellipse cx="100" cy="60" rx="30" ry="7" fill="none" stroke="#B39DDB" stroke-width="2" opacity="0.6" style="animation:float1 3.5s ease-in-out infinite"/>
                    <!-- Moon -->
                    <circle cx="152" cy="46" r="7" fill="#9FA8DA" style="animation:float3 3.2s ease-in-out infinite"/>
                    <!-- Stars -->
                    <circle cx="28" cy="22" r="2" fill="#C5CAE9" style="animation:blink 1.8s ease-in-out infinite"/>
                    <circle cx="162" cy="18" r="2.5" fill="#D1C4E9" style="animation:blink 2.4s ease-in-out infinite .5s"/>
                    <circle cx="176" cy="80" r="1.5" fill="#9FA8DA" style="animation:blink 2s ease-in-out infinite 1s"/>
                    <circle cx="18" cy="82" r="2" fill="#C5CAE9" style="animation:blink 1.5s ease-in-out infinite .3s"/>
                    <circle cx="58" cy="14" r="1.5" fill="#D1C4E9" style="animation:blink 2.8s ease-in-out infinite .8s"/>
                    <circle cx="180" cy="46" r="1.5" fill="#9FA8DA" style="animation:blink 3s ease-in-out infinite .6s"/>
                    <!-- Shooting star -->
                    <line x1="32" y1="48" x2="52" y2="54" stroke="#C5CAE9" stroke-width="1.2" opacity="0.7" stroke-linecap="round"/>
                    <circle cx="30" cy="47" r="1.5" fill="#D1C4E9" style="animation:blink 1.4s ease-in-out infinite .2s"/>
                  </svg>
                </ng-container>

                <!-- SVG 7: Doctorado en Derecho -->
                <ng-container *ngIf="i % 8 === 7">
                  <svg width="200" height="110" viewBox="0 0 200 120">
                    <!-- Center pillar -->
                    <rect x="98" y="22" width="4" height="60" rx="2" fill="#C8A415" style="animation:float1 3.2s ease-in-out infinite"/>
                    <!-- Top ornament -->
                    <circle cx="100" cy="18" r="5.5" fill="#C8A415" style="animation:float1 3.2s ease-in-out infinite"/>
                    <!-- Horizontal beam -->
                    <rect x="56" y="33" width="88" height="4" rx="2" fill="#5D4037" style="animation:float1 3.2s ease-in-out infinite"/>
                    <!-- Left chains -->
                    <line x1="68" y1="37" x2="63" y2="58" stroke="#C8A415" stroke-width="1.2" style="animation:float2 2.8s ease-in-out infinite"/>
                    <line x1="77" y1="37" x2="82" y2="58" stroke="#C8A415" stroke-width="1.2" style="animation:float2 2.8s ease-in-out infinite"/>
                    <!-- Left pan -->
                    <path d="M61 58 Q72 68 84 58" fill="rgba(200,164,21,0.18)" stroke="#C8A415" stroke-width="1.5" fill-opacity="0.18" style="animation:float2 2.8s ease-in-out infinite"/>
                    <!-- Right chains -->
                    <line x1="123" y1="37" x2="118" y2="58" stroke="#C8A415" stroke-width="1.2" style="animation:float3 3s ease-in-out infinite"/>
                    <line x1="132" y1="37" x2="137" y2="58" stroke="#C8A415" stroke-width="1.2" style="animation:float3 3s ease-in-out infinite"/>
                    <!-- Right pan -->
                    <path d="M116 58 Q127 68 139 58" fill="rgba(200,164,21,0.18)" stroke="#C8A415" stroke-width="1.5" fill-opacity="0.18" style="animation:float3 3s ease-in-out infinite"/>
                    <!-- Base -->
                    <rect x="82" y="82" width="36" height="5" rx="2.5" fill="#5D4037" style="animation:float1 3.2s ease-in-out infinite"/>
                    <!-- Decorative accents -->
                    <circle cx="168" cy="28" r="8" fill="#EFEBE9" stroke="#C8A415" stroke-width="1.5" style="animation:float2 3.8s ease-in-out infinite"/>
                    <circle cx="26" cy="58" r="5.5" fill="#EFEBE9" stroke="#C8A415" stroke-width="1.2" style="animation:float3 4.2s ease-in-out infinite"/>
                    <!-- Small star accent -->
                    <circle cx="170" cy="80" r="3" fill="#C8A415" opacity="0.4" style="animation:blink 2.2s ease-in-out infinite"/>
                    <circle cx="22" cy="30" r="2.5" fill="#C8A415" opacity="0.5" style="animation:blink 2.8s ease-in-out infinite .6s"/>
                  </svg>
                </ng-container>

              </div>
              <div class="prog-card-body">
                <p class="prog-card-area">
                  <ng-container *ngIf="i % 8 === 0">Tecnología</ng-container>
                  <ng-container *ngIf="i % 8 === 1">Salud Mental</ng-container>
                  <ng-container *ngIf="i % 8 === 2">Negocios</ng-container>
                  <ng-container *ngIf="i % 8 === 3">Ciencias Sociales</ng-container>
                  <ng-container *ngIf="i % 8 === 4">Salud Pública</ng-container>
                  <ng-container *ngIf="i % 8 === 5">Humanidades</ng-container>
                  <ng-container *ngIf="i % 8 === 6">Astronomía</ng-container>
                  <ng-container *ngIf="i % 8 === 7">Derecho</ng-container>
                </p>
                <h3 class="prog-card-title">{{item.nombre}}</h3>
                <p class="prog-card-desc">{{item.subtitulo}}</p>
                <a class="prog-card-link" (click)="ofertaAcademica()" style="cursor:pointer">
                  Oferta académica
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M2.5 7h9M8 3.5l3.5 3.5L8 10.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="ver-mas-wrap" style="margin-bottom: 15px !important;">
          <button class="btn-primary" (click)="verMas()">
            Ver toda la oferta académica &nbsp;<i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </section>

    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<!-- FOOTER -->
<footer id="footer">
  <div class="footer-top">
    <div class="footer-grid">
      <div class="footer-name">Universidad Nacional Autónoma de Honduras</div>
      <div class="footer-logo-wrap">
        <img src="../../assets/images/BackGround/logoUNAH.PNG" alt="UNAH" class="footer-logo imgPuma">
      </div>
      <div class="footer-contact">
        <h4>Contactos</h4>
        <p>
          Bulevar Suyapa, Tegucigalpa, M.D.C, Honduras<br>
          <strong>Tel:</strong> 2216-6100 / 2216-5100<br>
          <strong>Correo:</strong> <a href="mailto:info@unah.edu.hn">info@unah.edu.hn</a>
        </p>
        <div class="social-links">
          <!-- <a href="https://twitter.com/UNAH_hn"><i class="fab fa-twitter"></i></a> -->
          <a href="https://www.facebook.com/unahoficial"><i class="fab fa-facebook-f"></i></a>
          <a href="https://www.instagram.com/unahoficial/"><i class="fab fa-instagram"></i></a>
          <a href="https://www.youtube.com/unahoficial"><i class="fab fa-youtube"></i></a>
          <a href="https://www.linkedin.com/school/unahoficial"><i class="fab fa-linkedin-in"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <span>&copy; Derechos reservados <strong>Universidad Nacional Autónoma de Honduras</strong> {{ dateActual }}</span>
    <span>Desarrollado por la <a href="https://degt.unah.edu.hn" style="color: #de805e !important;">Dirección Ejecutiva de Gestión de Tecnología</a></span>
  </div>
</footer>

</body>
